import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Track from './pages/Track';
import Course from './pages/Course';
import Lesson from './pages/Lesson';
import Dashboard from './pages/Dashboard';
import Preferences from './pages/Preferences';
import Community from './pages/Community';
import CohortDetail from './pages/CohortDetail';
import Forum from './pages/Forum';
import Thread from './pages/Thread';
import StudyGroup from './pages/StudyGroup';
import CreateGroup from './pages/CreateGroup';
import Shift from './pages/Shift';
import BiasBingo from './pages/BiasBingo';
import Orientation from './pages/Orientation';
import SpotTheFlaw from './pages/SpotTheFlaw';
import PromptAutopsy from './pages/PromptAutopsy';
import BuddyChat from './pages/BuddyChat';
import Profile from './pages/Profile';
import Journal from './pages/Journal';
import CloseReadingPractice from './pages/CloseReadingPractice';
import FixIt from './pages/FixIt';
import Start from './pages/Start';
import ProtectedRoute from './components/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Terms, Privacy, Cookies, Refund, Accessibility } from './pages/legal';

export default function App() {
  return (
    <ErrorBoundary>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="start" element={<Start />} />
        <Route path="fix-it" element={<FixIt />} />
        <Route path="shift" element={<Shift />} />
        <Route path="bingo" element={<BiasBingo />} />
        <Route path="orientation" element={<Orientation />} />
        <Route path="spot-the-flaw" element={<SpotTheFlaw />} />
        <Route path="autopsy" element={<PromptAutopsy />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="tracks/:slug" element={<Track />} />
        <Route path="courses/:slug" element={<Course />} />
        <Route
          path="lessons/:id"
          element={
            <ProtectedRoute>
              <Lesson />
            </ProtectedRoute>
          }
        />
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="preferences"
          element={
            <ProtectedRoute>
              <Preferences />
            </ProtectedRoute>
          }
        />
        <Route
          path="profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="journal"
          element={
            <ProtectedRoute>
              <Journal />
            </ProtectedRoute>
          }
        />
        <Route
          path="close-reading"
          element={
            <ProtectedRoute>
              <CloseReadingPractice />
            </ProtectedRoute>
          }
        />
        {/* Community Pages */}
        <Route path="community" element={<Community />} />
        <Route path="cohorts/:id" element={<CohortDetail />} />
        <Route path="forums/:forumId" element={<Forum />} />
        <Route path="threads/:threadId" element={<Thread />} />
        <Route path="groups/:id" element={<StudyGroup />} />
        <Route
          path="groups/create"
          element={
            <ProtectedRoute>
              <CreateGroup />
            </ProtectedRoute>
          }
        />
        {/* Buddy Chat */}
        <Route
          path="buddy/chat"
          element={
            <ProtectedRoute>
              <BuddyChat />
            </ProtectedRoute>
          }
        />
        {/* Legal Pages */}
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="cookies" element={<Cookies />} />
        <Route path="refund" element={<Refund />} />
        <Route path="accessibility" element={<Accessibility />} />
      </Route>
    </Routes>
    </ErrorBoundary>
  );
}
